import React from 'react';
import { EmptyState } from '../../../../components/EmptyState';
import GenerateButton from '../GenerateButton';

export default function ListPageEmptyState(props: { disabled: boolean }) {
  const disabled: boolean = props.disabled ?? false;
  return (
    <EmptyState
      title='No API Keys created yet'
      text='Create your first API key to start using it on your jobs.'
      cardless={true}
      actionButton={
        <div className='mt-3'>
          <GenerateButton disabled={disabled} />
        </div>
      }
    />
  );
}
